export default __webpack_public_path__ + "static/media/on-demand-alert.0c15f846.mp3";